class Logger {
  Debug(obj: any, message: string) {
    let label: string;
    if (typeof obj === 'function') {
      label = obj.name;
    } else {
      label = obj.toString();
    }
    console.log(`${label}: ${message}`);
  }
}

export const Log = new Logger();
